import appStore from 'store';
import api from './api';
import { STATUS_TYPS } from './constants';

const store = {
  namespaced: true,
  state: {
    currencies: [],
    coinList: [],
    currencyDetail: {}
  },
  getters: {
    currencyList(state) {
      return state.currencies.map(item => ({
        ...item,
        __status: STATUS_TYPS[item.status]
      }));
    }
  },
  mutations: {
    setCurrencyList(state, payload) {
      state.currencies = payload.slice();
    },
    setBannerDetail(state, payload) {
      state.currencyDetail = Object.assign({}, payload);
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    list({ commit }) {
      return api.getCurrencyList().then(({ data }) => {
        commit('setCurrencyList', data);
      });
    },
    detail({ commit }, id) {
      return api.getCurrencyDetail(id).then(({ data }) => {
        commit('setBannerDetail', data);
      });
    },
    create({ commit }, data) {  // eslint-disable-line
      return api.addCurrency(data);
    },
    bind({ commit }, id) {  // eslint-disable-line
      return api.bindThirdPart(id);
    },
    getCoinList({ commit }, id) {
      // eslint-disable-line
      return api.getCoinList(id).then(({ data }) => {
        commit('setCoinList', data);
      });
    }
  }
};

appStore.registerModule('myTokenCurrency', store);
